import { useState } from "react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function ToggleRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const [pressed, setPressed] = useState(false)

  const label = element.text ? String(resolveSymbol(element.text) ?? "") : ""
  const isOutline = element.variant === "outline"
  const isDisabled = element.disabled === true

  const handleClick = () => {
    if (isDisabled) return
    const newPressed = !pressed
    setPressed(newPressed)
    dispatchEvent(element.id, "tap", { pressed: newPressed })
  }

  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors h-9 px-3",
        pressed
          ? "bg-accent text-accent-foreground"
          : isOutline
            ? "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground"
            : "bg-transparent hover:bg-muted hover:text-muted-foreground",
        isDisabled && "pointer-events-none opacity-50",
        element.className
      )}
      onClick={handleClick}
      disabled={isDisabled}
      aria-pressed={pressed}
      aria-label={element.ariaLabel ?? label}
      data-testid={`toggle-${element.id}`}
    >
      {label}
    </button>
  )
}
